// extracted by mini-css-extract-plugin
export var bikeIcon = "iZb6wcLy3LQSkWhM7FDV";
export var bikeReservations = "Rs5IrrcywvVe0qQg2xe6";
export var count = "MZifxeCdka7jywk1KHDO";
export var spacer = "NlQecNu7UDY0kp9QKf3f";